export var NetworkObjectType;
(function (NetworkObjectType) {
    NetworkObjectType[NetworkObjectType["Avatar"] = 0] = "Avatar";
    NetworkObjectType[NetworkObjectType["Controller"] = 1] = "Controller";
})(NetworkObjectType || (NetworkObjectType = {}));
// base class for the synchronization of network objects
export class NetworkObject {
    get objectType() {
        return this.constructor.staticObjectType;
    }
    constructor(ownerId, netUid) {
        this.ownerId = ownerId;
        this.netUid = netUid;
    }
    get constructorByteLength() {
        return this._constructorByteLength;
    }
}
